import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import UpgradePlanButton from '../UpgradePlanButton';
import ProcessingSpinner from '../ProcessingSpinner';

const AdminHeader = ({
  title,
  icon,
  feature,
  itemName,
  itemsVisible,
  itemsTotal,
  itemsSubItems,
  showNewItemButton,
  showActionButton,
  actionButtonLoading,
  newItemTitle,
  actionButtonTitle,
  loading,
  handleNewItem,
  handleActionButton,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header with-upgrade-button">
      <h2 className="page-title">
        {icon && (
          <i className={`far ${icon}`} />
        )}
        {title}
      </h2>
      <UpgradePlanButton feature={feature} />
      <div className="header-actions">
        <div className="items-displaying">
          {(!loading && itemsTotal > 0) && (
            <span>
              {intl.formatMessage({
                defaultMessage: `{itemsVisible} of {itemsTotal} {itemName}{itemsTotal, plural, one {} other {s}}`,
              }, { itemsVisible, itemsTotal, itemName })}
              {itemsSubItems.length > 0 && (
                <span className="sub">
                  {' '}
                  ({itemsSubItems.join(', ')})
                </span>
              )}
            </span>
          )}
        </div>
        {showNewItemButton && (
          <div className="button-wrapper">
            <Button color="primary" onClick={handleNewItem}>
              <i className="fas fa-plus" />
              <span>
                {newItemTitle}
              </span>
            </Button>
          </div>
        )}
        {showActionButton && (
          <div className="button-wrapper">
            <Button
              color="secondary"
              onClick={handleActionButton}
              className="page-header-action-button"
            >
              <ProcessingSpinner show={actionButtonLoading} />
              <span>
                {actionButtonTitle}
              </span>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

AdminHeader.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  feature: PropTypes.string,
  itemName: PropTypes.string.isRequired,
  itemsVisible: PropTypes.string.isRequired,
  itemsTotal: PropTypes.number.isRequired,
  itemsSubItems: PropTypes.array,
  showNewItemButton: PropTypes.bool,
  showActionButton: PropTypes.bool,
  actionButtonLoading: PropTypes.bool,
  newItemTitle: PropTypes.string,
  actionButtonTitle: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  handleNewItem: PropTypes.func,
  handleActionButton: PropTypes.func,
};

AdminHeader.defaultProps = {
  icon: null,
  feature: null,
  itemsSubItems: [],
  showNewItemButton: true,
  showActionButton: false,
  actionButtonLoading: false,
  newItemTitle: '',
  actionButtonTitle: '',
  handleNewItem: () => {},
  handleActionButton: () => {},
};

export default AdminHeader;
